import { MembershipsSpotifyIntegrationsApiClient } from '@fourthwall/services/dist/MembershipsSpotifyIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdatePodcastMutation = createMutationHook(
  MembershipsSpotifyIntegrationsApiClient.updatePodcast,
  {
    mutationKey: ['updatePodcast'],
  },
)
